import { KpiCard } from "./ui/KpiCard";

/** @deprecated Use KpiCard from ./ui — kept for backward compatibility */
export const CardComponent = (props) => <KpiCard {...props} className={props.className || ""} />;

export { KpiCard };
